<template>
  <table class="c-table">
    <thead class="header" :style="{ borderRight: `${tableScrollWidth} solid transparent` }">
      <tr class="row">
        <!-- @slot The table's header section slot. -->
        <slot name="header">
          <th
            v-for="(col, index) in cols"
            :key="index"
            :class="getClasses(index, 'header')"
            :style="getStyle(col)"
            :width="col.width || null"
          >
            <span class="text">{{ getText(col, 'label') }}</span>
          </th>
        </slot>
      </tr>
    </thead>

    <div :class="[ 'body-wrapper', { '-grey-shadow': greyShadow } ]">
      <component
        :is="skipTransition ? 'table-body' : 'c-transition'"
        ref="tableBody"
        ref-cy="table-body"
        group
        class="body"
        tag="tbody"
        @scroll.native="emitPaginate"
      >
        <!-- @slot The table row slot, contains a default row
             filled with the row's content.
        -->
        <slot name="row">
          <tr
            v-for="(row, rowIndex) in rows"
            :key="rowIndex"
            class="row"
          >
            <td
              v-for="(col, colIndex) in cols"
              :key="colIndex"
              :class="getClasses(colIndex, 'content')"
              :style="getStyle(col)"
              :width="col.width || null"
            >
              <span class="text">{{ getText(row, col.field) }}</span>
            </td>
          </tr>
        </slot>
      </component>
    </div>

    <!-- @slot A slot for the table's footer section. -->
    <slot name="footer" />
  </table>
</template>

<script>
import { Shadowed as _Shadowed } from '@convenia/mixins'
import TableBody from './fragments/TableBody'
import CTableMixin from './CTableMixin'

// A little hack necessary circumvent one of vue-docgen-api bugs:
// https://github.com/vue-styleguidist/vue-docgen-api/issues/53
const Shadowed = _Shadowed || function derp () {}

/**
 * An hybrid model/template -driven table component.
 */
export default {
  name: 'CTable',
  components: { TableBody },
  inheritAttrs: false,

  mixins: [ Shadowed({ refName: 'tableBody' }), CTableMixin ]
}
</script>

<style lang="scss">
@import './style.scss';
</style>
